import React from 'react';
import ReactDOM from 'react-dom';
import ConnectToStores from '../Utilities/Decorators/ConnectToStoresDecorator';
import NotificationStore from '../Stores/NotificationStore';
import AutoScopeStyles from '../Utilities/Decorators/AutoScopeStylesDecorator';
import NotificationsView from './NotificationsView.jsx';
import { Sticky } from 'semantic-ui-react';
import applyDecoratorsDoNotUseInNewCode from '../Utilities/Decorators/ApplyDecorators';

class StickyNotificationsView extends React.PureComponent {
    state = { notificationHeightInPixels: 0 };

    static getStores() {
        return [NotificationStore];
    }

    static getPropsFromStores() {
        return NotificationStore.getState();
    }

    render() {
        if(!this.props.notificationDetails)
            return null;

        return (
            <div style={{ height: (this.state.notificationHeightInPixels + "px") }}>
                <Sticky
                    context={ document.querySelector("[data-reactroot]") /* unfortunately, in this app, document.body doesn't encompass the entire screen for some reason */ }
                    offset={ 44 }
                    ref={ this.setStickyRef }
                >
                    <NotificationsView />
                </Sticky>
            </div>
        );
    }

    componentDidMount() {
        this.saveElementHeight();
    }

    componentDidUpdate() {
        this.saveElementHeight();
    }

    saveElementHeight() {
        if(!this.stickyRef)
            return;     //HACK: not sure why we get called without a Ref at this point

        const domElement = ReactDOM.findDOMNode(this.stickyRef);
        //need to find height of child because the Sticky component has no height if it is stuck
        const notificationHeightInPixels = Array.from(domElement.childNodes).reduce((height,c) => Math.max(c.clientHeight, height), 0);
        this.setState({ notificationHeightInPixels });
    }

    setStickyRef = stickyRef => this.stickyRef = stickyRef
}

const withDecorators = applyDecoratorsDoNotUseInNewCode(ConnectToStores, AutoScopeStyles);

export default withDecorators(StickyNotificationsView);
